import { render, staticRenderFns } from "./CIDRAddressingForm.vue?vue&type=template&id=27c5f884&"
import script from "./CIDRAddressingForm.vue?vue&type=script&lang=js&"
export * from "./CIDRAddressingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports